import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');

  const footerColumns = [
    {
      title: t('footer.brandStory'),
      links: [
        { label: t('footer.brandOrigin'), href: '/about' },
        { label: t('footer.rdTeam'), href: '/about' },
        { label: t('footer.brandVision'), href: '/about' },
      ],
    },
    {
      title: t('footer.coreTechnology'),
      links: [
        { label: t('footer.freezeDry'), href: '/technology' },
        { label: t('footer.microEncapsulation'), href: '/technology' },
        { label: t('footer.coldExtraction'), href: '/technology' },
      ],
    },
    {
      title: t('footer.productSeries'),
      links: [
        { label: t('footer.functionalGummies'), href: '/products' },
        { label: t('footer.freezeDriedTonics'), href: '/products' },
        { label: t('footer.herbalEnergyBars'), href: '/products' },
      ],
    },
    {
      title: t('footer.sustainability'),
      links: [
        { label: t('footer.cleanLabel'), href: '/sustainability' },
        { label: t('footer.greenSupplyChain'), href: '/sustainability' },
        { label: t('footer.circularPackaging'), href: '/sustainability' },
      ],
    },
  ];

  const socials = [
    { icon: 'ri-wechat-fill' },
    { icon: 'ri-weibo-fill' },
    { icon: 'ri-instagram-fill' },
    { icon: 'ri-tiktok-fill' },
  ];

  return (
    <footer className="bg-brand-sand">
      {/* Top: Navigation Columns */}
      <div className="w-full px-6 md:px-10 lg:px-16 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-brand-charcoal mb-3 whitespace-nowrap">
                {col.title}
              </h4>
              <div className="w-8 h-[2px] bg-brand-mint-dark mb-4" />
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-brand-gray hover:text-brand-charcoal transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Divider */}
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="h-px bg-brand-gray-pale/60" />
      </div>

      {/* Bottom: Brand & Info */}
      <div className="w-full px-6 md:px-10 lg:px-16 py-10 md:py-14">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          {/* Left: Brand */}
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/f5d75575-149e-42fd-8f5e-baf597e2961c/14b65f89-5db4-4044-8463-e06c231de31a_unnamed.png?v=45f66e64fb7ba855e9bbff4adf44ae01"
                alt={t('brand.name') + ' ' + t('brand.nameEn')}
                className="h-10 md:h-14 w-auto object-contain"
              />
            </div>
            <div className="flex items-center gap-3">
              <div className="w-8 h-[2px] bg-brand-mint-dark" />
              <span className="text-sm text-brand-gray">{t('footer.contact')}</span>
            </div>
          </div>

          {/* Right: Copyright & Social */}
          <div className="flex flex-col items-start md:items-end gap-4">
            <p className="text-xs text-brand-gray-light">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-3">
              {socials.map((social) => (
                <a
                  key={social.icon}
                  href="https://foodgogo.org/"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-brand-charcoal/5 text-brand-gray hover:bg-brand-charcoal hover:text-white transition-all"
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}